var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruckX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.61899L4 7.41899V16.646L12 19.846L20 16.646V7.41899L12 4.61899ZM12.3304 2.61565C12.1165 2.5408 11.8835 2.5408 11.6696 2.61565L2.66965 5.76565C2.26856 5.90603 2 6.28457 2 6.70951V17.323C2 17.7319 2.24895 18.0996 2.62861 18.2515L11.6286 21.8515C11.867 21.9468 12.133 21.9468 12.3714 21.8515L21.3714 18.2515C21.751 18.0996 22 17.7319 22 17.323V6.70951C22 6.28457 21.7314 5.90603 21.3304 5.76565L12.3304 2.61565Z",
    className: "Icon-fill-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.63755 7.43203L3.36245 5.56802L12 8.92707L20.6376 5.56802L21.3624 7.43203L12 11.073L2.63755 7.43203Z",
    className: "Icon-fill-color"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49978 4.00003L17.5 7.30703V10.5C17.5 11.0523 17.0523 11.5 16.5 11.5C15.9477 11.5 15.5 11.0523 15.5 10.5V8.69303L7.21255 5.58523L8.49978 4.00003Z",
    className: "Icon-fill-color"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 20.5V10H13V20.5H11Z",
    className: "Icon-fill-color"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.7215C5 10.3724 5.34869 10.1308 5.67556 10.2534L8.67556 11.3784C8.87071 11.4515 9 11.6381 9 11.8465V15.2785C9 15.6276 8.65131 15.8693 8.32444 15.7467L5.32444 14.6217C5.12929 14.5485 5 14.3619 5 14.1535V10.7215Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckX2);
export default __webpack_public_path__ + "static/media/TruckX2.bfeb0d25af838a2b951194f49a44b328.svg";
export { ForwardRef as ReactComponent };